import {getDevice} from "framework7/shared/get-device";

export default class UtilsService {
    private static instance?: UtilsService;

    static of() {
        if (typeof UtilsService.instance === 'undefined') UtilsService.instance = new UtilsService();
        return UtilsService.instance;
    }

    async openTelegramSupportChat() {
        const url = "https://t.me/BroMoneySupport_bot";

        try {
            if (getDevice().cordova) {
                // @ts-ignore
                window.cordova.InAppBrowser.open(url, '_system');
            } else {
                window.open(url, "_target");
            }
        } catch (e) {
          window.open(url, "_target");
        }
    }

  currencyFormatter(currency: "RUB" | "USD" | "USDT" | "KZT") {
    const locale = currency === "KZT" ? "ru-KZ" : "ru-RU";
    const realCurrency = currency === "USDT" ? "USD" : currency;

    const formatter = new Intl.NumberFormat(locale, {
      style: "currency",
      currency: realCurrency,
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    });

    return {
      format(value: number) {
        let formatted = formatter.format(value);
        formatted = formatted.replace(',', '.');

        if (currency === "USDT") {
          return formatted.replace('$', "USDT");
        }
        return formatted;
      }
    };
  }
}
